import activeIcon from '../../../assets/images/active-icon.svg'
import completeIcon from '../../../assets/images/complete-icon.svg'
import targetIcon from '../../../assets/images/target-icon.svg'

const sidebarItems = [
  { value: 1, title: 'Testing for Fentanyl', slot: 'testing-for-fentanyl', icon: completeIcon, webPageUrl: 'https://dopa.ge/testing-fentanyl' },
  { value: 2, title: 'Good Samaritan Laws', slot: 'good-samaritan-laws', icon: activeIcon, webPageUrl: 'https://dopa.ge/good-samaritan-overdose' },
  { value: 3, title: 'Your Policies', slot: 'your-campus-policies', icon: targetIcon, webPageUrl: '' }
]

export default sidebarItems
